import axios from "axios";
import $day from "dayjs"
const module = {
  namespaced: true,
  state: {
    data: {
      user_moves: '',
    },
  },
  mutations: {
    fetchData: (state, info) => {
      if(info.user_moves) {
        info.user_moves.filter((item) => {
          item.editableFlag = true
          item.modal = false
          item.datetime = item.datetime.substring(0,10)
          return item
        })
        state.data = info
      } else {
        state.data = []
      }
    },
    addData: (state, info) => {
      info.user_moves.editableFlag = true
      info.user_moves.datetime = $day(info.user_moves.datetime).format('YYYY-MM-DD')
      state.data.user_moves.push(info.user_moves)
    },
    updateData: (state, info) => {
      return state.data.user_moves = state.data.user_moves.map((item) => {
        if (item.id === info.user_moves.id) {
          info.user_moves.datetime = $day(info.user_moves.datetime).format('YYYY-MM-DD')
          item.datetime = info.user_moves.datetime
          return item
        } else {
          return item
        }
      })
    },
    removeData: (state, info) => {
      return state.data.user_moves = state.data.user_moves.filter((item) => {
        return item.id != info
      })
    },
  },
  actions: {
    async fetchData ({commit, rootState}) {
      const response = await axios.get('admin/users/data/'+rootState.user.currentUser)
      commit ('fetchData', response.data.user_data)
    },
    async updateData ({commit}, data) {
      data.datetime = $day(data.datetime).format('YYYY-MM-DD HH:mm:ss')
      const response = await axios.put('admin/user/data/moves/'+data.id, data)
      commit ('updateData', response.data)
    },
    async addData ({commit, rootState}, data) {
      data.datetime = $day(data.datetime).format('YYYY-MM-DD HH:mm:ss')
      data.user_id = rootState.user.currentUser
      const response = await axios.post('admin/user/data/moves', data)
      commit ('addData', response.data)
    },
    async removeData ({commit}, id) {
      await axios.delete('admin/user/data/moves/'+id).then(() => {
        commit ('removeData', id)
      })
    },
  }
}
export default module
